import { Box, ModBox } from '@jfs/ui-new'
import { useNavigation } from '@react-navigation/native'
import { FC } from 'react'
import { SvgImage } from '../SvgImage'
export const HeaderLeft: FC = () => {
  const navigation = useNavigation()
  return (
    <Box backgroundColor={'TRANSPARENT'} flexDirection="row" justifyContent="center" alignItems={'center'} h={64}>
      <ModBox
        paddingLeft={25}
        paddingRight={10}
        show={navigation?.canGoBack()}
        underlayColor={'TRANSPARENT'}
        testID="back-arrow"
        onPress={() => navigation?.goBack()}>
        <SvgImage imageName="HeaderArrowLeft" />
      </ModBox>
    </Box>
  )
}
